import { Story } from '../../DocTypes';

export const avatarStory: Story = {
  title: 'Avatar',
  description: 'List with items with an avatar',
  coreComponent: {
    html: `<tag-list
  avatar-src-field='image'
  avatar-placeholder-field='placeholder'
  avatar-size='40px'
  primary-field='name'>
    </tag-list>`,
    js: `var tagList = document.querySelector('tag-list');
  tagList.componentOnReady().then(function() {
    tagList.setData([
      {
        image:
          'https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260',
          name: 'Jordan Norry',
          placeholder: 'JN',
      },
      {
        image: '',
        name: 'Sarah Young',
        placeholder: 'SY',
      },
      {
        image:
          'https://images.pexels.com/photos/324658/pexels-photo-324658.jpeg?auto=compress&cs=tinysrgb&h=350',
        name: 'Susan Warmly',
        placeholder: 'SW',
      },
      {
        image: '',
        name: 'Derek Been',
        placeholder: 'DB',
      },
      {
        image: '',
        name: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.',
        placeholder: 'JN',
      }
    ]);
  });
  `,
  },
  reactWrapper: {
    jsx: `<TagList
  avatarSrcField='image'
  avatarPlaceholderField='placeholder'
  avatarSize='40px'
  primaryField='name'
  data={[
  {
    image:
      'https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260',
      name: 'Jordan Norry',
      placeholder: 'JN',
  },
  {
    image: '',
    name: 'Sarah Young',
    placeholder: 'SY',
  },
  {
    image:
      'https://images.pexels.com/photos/324658/pexels-photo-324658.jpeg?auto=compress&cs=tinysrgb&h=350',
    name: 'Susan Warmly',
    placeholder: 'SW',
  },
  {
    image: '',
    name: 'Derek Been',
    placeholder: 'DB',
  },
  {
    image: '',
    name: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.',
    placeholder: 'JN',
  }
  ]}
  />`,
  },
};
